const mobileNavScroll = function(){

  let body;

  const _init = function(){
    body = document.body;

    _addEventListeners();
  };

  const _addEventListeners = function(){
    window.addEventListener('scroll', _applyClass);
  };

  const _applyClass = function(){
    body.classList.add('is-scrolled');

    if (body.classList.contains('is-scrolled') && window.pageYOffset === 0) {
      body.classList.remove('is-scrolled');
    }
  };


  return{
    init: _init
  }
}();

export default mobileNavScroll;


// WEBPACK FOOTER //
// ./resources/assets/js/partials/MobileNavHomepage.js